<template>
  <div class="of-h" v-loading="loading">
    <div class="flex-box al-c card-title">
      <i class="myfont icon-dingdan"></i>
      <span class="font-20">日程</span>
    </div>
    <div class="pt10">
      <div class="item" v-for="(item, index) in list" :key="index">
        <a class="block app-item" :href="item.scheduleUrl" target="_blanck">
          <i class="app-img"></i>
          <div class="item-con">
            <p class="title ellipsis">{{ item.title }}</p>
            <p class="con ellipsis">
              <span>{{ item.address }}</span>
              <span>{{ item.beginTime | filterDate("yyyy-MM-dd h:m") }} - {{ item.endTime | filterDate("h:m") }}</span>
            </p>
          </div>
        </a>
      </div>
      <el-col class="pt20 pb20 tx-c grey font-14" :span="24" v-if="list.length == 0">暂无日程</el-col>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CardSchedule",
  components: {},
  props: ["w", "h"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      list: [],
      rootUrl: ""
    };
  },
  computed: {
    ...mapGetters(["userToken"])
  },
  created() {
    this.fetchList();
    this.rootUrl = "//" + this.$base.dataUrl.split("//")[1];
  },
  mounted() {},
  destroyed() {},
  methods: {
    fetchList () {
      this.loading = true;
      let obj = {};
      if( this.h == 1 ){
        obj.pageSize = 4;
      } else if( this.h == 2 ) {
        obj.pageSize = 9;
      }
      obj.pageNum = 1;
      this.$http.post("/calendarSchedule/pageList", obj )
      .then( ({ data }) => {
        if( data.resCode == 0){
          data.resData.list.forEach( (e, index) => {
            this.list.push({
              id: index,
              title: e.scheduleTitle,
              address: e.scheduleAddress,
              beginTime: e.beginTime,
              endTime: e.endTime,
              scheduleUrl: e.calendarScheduleUrl.replace("ip:port", this.rootUrl) + `&sid=${this.userToken}`
            })
          })
        }
        this.loading = false;
      })
      .catch( () =>{
        this.loading = false;
      })
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
  .card-title {
    height: 40px;
  }
  
  .card-title i {
    color: #619df8;
    font-size: 20px;
    margin-left: 10px;
    margin-right: 5px;
  }
  
  .item {
    padding: 7px 10px;
  }
  
  .app-item {
    display: flex;
    flex-direction: row;
    padding: 8px 10px;
    padding-left: 0;
    border: 1px solid #eeeeee;
    border-radius: 4px;
  }
  
  .app-img {
    width: 5px;
    height: 40px;
    background-color: #f8835f;
    border-radius: 0 8px 8px 0;
  }

  .item-con {
    flex: 1;
    width: 100%;
    padding-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
  }
  
  .item-con p {
    width: 100%;
    color: #888888;
    text-align: left;
  }
  
  .item-con p.title {
    color: #333333;
    font-size: 16px;
    padding-bottom: 4px;
  }

  .item-con p.con {
    display: flex;
    padding-left: 15px;
    flex-direction: row;
    justify-content: space-between;
    position: relative;
  }
  
  .item-con p.con::before {
    width: 8px;
    height: 11px;
    content: '';
    background-image: url(../../../../public/images/address.png);
    position: absolute;
    top: 4px;
    left: 0px;
  }
  
</style>
